import cn from "classnames";
import { bem } from "@react-md/utils";
import { useInheritContext } from "./useInheritContext";
var block = bem("rmd-app-bar");
/**
 * This is a hook that will apply the nav classnames to an element. This should
 * really not be used externally and is really just for creating dropdown menus
 * within app bars that have the action styles.
 *
 * @internal
 */
export function useActionClassName(_a) {
    var _b = _a === void 0 ? {} : _a, first = _b.first, last = _b.last, inheritColor = _b.inheritColor, className = _b.className;
    return cn(block("action", {
        first: first,
        last: last,
        inherit: useInheritContext(inheritColor),
    }), className);
}
//# sourceMappingURL=useActionClassName.js.map